import { FILTER_CLIENTS, GET_ALLOW_CLIENTS, GET_ID_CLIENT_DATA } from "../graphql/query/clients/query";
import { PASSWORD_RESET_CLIENT } from "../graphql/mutations/clients/mutations";
import { apiRequests } from "../services/api";

/** QUERY */

export const getClientId = async(id_client) => {
    try {
        //console.log('123',id_client);
        const variables = {
            id:String(id_client)
        }

        const response = await apiRequests(GET_ID_CLIENT_DATA , variables);
        //console.log(response.data.getClientId.client_int);
        if(response != null ){
            return response.data.getClientId.client_int;
        }else{
            return null;
        }
    } catch (err) {
        console.warn( 'Surgio un problema en el servidor' , err );
        return [];
    }
}

export const getAllowClient = async() => {
    try {
        const response = await apiRequests(GET_ALLOW_CLIENTS);
        //console.log('resp111: ', response);
        if(response.data.listClientAllow?.result){
            return response.data.listClientAllow;
        }else{
            return response.data.listClientAllow.result;
        };
        
    } catch($e){
        console.log('Se produjo un error en el fronted: ' , $e);
        return [];
    }
};

export const filtersClient = async(filters = {})=>{
    try{
        const variables = {
            requestSearchData:filters
        };

        const response = await apiRequests(FILTER_CLIENTS,variables);
        //console.log(response.data.filterSearchclient.result);
        if(response.data.filterSearchclient.result){
            
            return response.data.filterSearchclient;
        }else{
            
            return response.data.filterSearchclient;
        }
        //console.log(response);
    } catch ($e){
        console.error('Fallas en el fronted: ' , $e);
    }
}

/** MUTATIONS */
export const passwordResetClient = async (id_client,new_password) => {
    const variables = {
        id_client: id_client,
        new_password: new_password
    }
    try {
        const response = await apiRequests(PASSWORD_RESET_CLIENT, variables);
        //console.log('resp22:',response);
        if(response.data.resetPasswordTechnician?.result){
            return response.data.resetPasswordClient;
        }else{
            return response.data.resetPasswordClient;
        }
    }catch($e){
        console.warn('Se produjo un error en el fronted: ' , $e);
        return [];
    }
};